const socials = state => state.contacts.social;
const emails = state => state.contacts.email;

export default {
  socials,
  emails,
};
